import { render, staticRenderFns } from "./ParamTipoDoc.vue?vue&type=template&id=06a50c4c"
import script from "./ParamTipoDoc.vue?vue&type=script&lang=js"
export * from "./ParamTipoDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports